module.exports = __webpack_public_path__ + "img/24.a8dd591a.jpg";